import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { COLLECT_EMAIL_ADDRESS } from '@zr/jobseeker-public/apps/jobseeker-screens/components/screenTypeSchema';
import { ApplyForm } from './ApplyForm';
import screenTypeTelemetry from '../screenTypeTelemetry';
import { applyDataPropTypes } from '../../../applyFlowPropTypes';

function CollectEmailAddressScreenType({
  applyData,
  isLoading,
  onError,
  onScreenTypeFinish,
  setIsLoading,
  toggleExistingEmailModal,
}) {
  // Set up telemetry for the screen type
  const {
    logFinish,
    logView,
  } = screenTypeTelemetry(COLLECT_EMAIL_ADDRESS, applyData);

  // Log initial screen view
  useEffect(() => {
    logView();
  }, [logView]);

  // Set up what the screen type should do upon successfully creating a
  // JobSeeker from the email collection
  const handleScreenTypeFinish = async () => {
    logFinish();
    await onScreenTypeFinish();
  };

  // The Google Sign-In Component depends on the following global variable:
  //   zr.page.model.GOOGLE_SIGNIN_CLIENT_ID
  const googleSignInProps = {
    onSuccessfulSignIn: handleScreenTypeFinish,
    onIsLoading: () => setIsLoading(true),
    onReady: () => setIsLoading(false),
    pageType: applyData.method,
    showBottomDivider: true,
  };

  return (
    <ApplyForm
      encryptedQuizId={applyData.encryptedQuizId}
      googleSignInProps={googleSignInProps}
      isLoading={isLoading}
      method={applyData.method}
      onContinue={handleScreenTypeFinish}
      onError={onError}
      onExistingEmail={toggleExistingEmailModal}
      setIsLoading={setIsLoading}
    />
  );
}

CollectEmailAddressScreenType.propTypes = {
  applyData: applyDataPropTypes.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onError: PropTypes.func,
  onScreenTypeFinish: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func,
  toggleExistingEmailModal: PropTypes.func,
};

CollectEmailAddressScreenType.defaultProps = {
  onError: () => {},
  setIsLoading: () => {},
  toggleExistingEmailModal: () => {},
};


export default CollectEmailAddressScreenType;
